import { IMutationsMock } from "./mutations.types";

export const mockMutations = (): IMutationsMock => ({
  // Root
  SET_LOCALE: jest.fn(),
  SET_URL: jest.fn(),
  SET_IS_SIGNED_IN: jest.fn(),
  SET_LOGGED_USER: jest.fn(),

  // Country
  SET_COUNTRIES: jest.fn(),
});
